import { v4 as uuid } from 'uuid';

export const getClientId = () => {
  let clientId = localStorage.getItem('clientId');

  if (!clientId) {
    clientId = uuid();
    localStorage.setItem('clientId', clientId);
  }

  return clientId;
};
